export const MAX_DRAG_PX = 50;

type PointerEventDetail = { detail: TouchEvent | MouseEvent };

type PointerStartXRef = { current: number | null };

function getClientX(event: TouchEvent | MouseEvent): number {
  return "touches" in event ? event.touches[0]?.clientX ?? 0 : event.clientX;
}

type CreatePointerHandlersOptions = {
  pointerStartX: PointerStartXRef;
  onDragExceeded: () => void;
  maxDragPx?: number;
};

export function createSalaryHeroCarouselPointerHandlers({
  pointerStartX,
  onDragExceeded,
  maxDragPx = MAX_DRAG_PX,
}: CreatePointerHandlersOptions) {
  const handlePointerDown = (_: unknown, event: PointerEventDetail) => {
    pointerStartX.current = getClientX(event.detail);
  };

  const handlePointerMove = (_: unknown, event: PointerEventDetail) => {
    if (pointerStartX.current === null) return true;
    const currentX = getClientX(event.detail);
    const dragDistance = Math.abs(currentX - pointerStartX.current);
    if (dragDistance > maxDragPx) {
      pointerStartX.current = null;
      onDragExceeded();
      return false;
    }
    return true;
  };

  const handlePointerUp = () => {
    pointerStartX.current = null;
  };

  return { handlePointerDown, handlePointerMove, handlePointerUp };
}
